import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarObligaciones = () => {
  const { id } = useParams(); // ID del contrato
  const [obligaciones, setObligaciones] = useState([]);

  // Obtener obligaciones por contrato
  const getData = useCallback(async () => {
    try {
      const response = await axios.get(`/api/obligaciones/contrato/${id}`);
      if (response.data.ok) {
        const data = response.data.obligaciones.map((item, index) => ({
          numero: index + 1,
          observacion: item.observacion,
          _id: item._id,
          funciones: (
            <div className="d-flex justify-content-center gap-2">
              <button
                className="btn btn-danger"
                style={{ width: 30, height: 30, padding: 0 }}
                title="Eliminar"
                onClick={() => deleteObservacion(item._id)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          )
        }));

        setObligaciones(data);
      }
    } catch (error) {
      console.error('Error al cargar las obligaciones:', error.message);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const deleteObservacion = async (idObligacion) => {
    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: 'Esta obligación será eliminada permanentemente',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (!result.isConfirmed) return;

    try {
      const { data } = await axios.delete(`/api/obligaciones/delete/${idObligacion}`);

      // Actualizar la lista de forma optimista
      setObligaciones((prev) =>
        prev.filter((ob) => ob._id !== idObligacion)
      );

      Swal.fire({
        icon: 'success',
        title: data.message || 'Obligación eliminada correctamente',
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error('Error al eliminar la obligación:', error.message);
      Swal.fire(
        'Error',
        error.response?.data?.message || 'No se pudo eliminar la obligación',
        'error'
      );
      getData(); // Intentar sincronizar la lista
    }
  };



  // Columnas
  const columns = [
    { Header: 'N°', accessor: 'numero' },
    { Header: 'Obligación', accessor: 'observacion' },
    { accessor: 'funciones' },
  ];

  return (
 <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1 className="mb-4">Obligaciones Contractuales</h1>
      <DataTable columns={columns} data={obligaciones} />
    </div>
  );
};

export default ListarObligaciones;
